import NavbarMio from "./NavbarMio";

export default function CardContenedorAdmin({ children, ruta }) {

    return (
        <div className="row">
            <div className="d-flex justify-content-center mt-4 mb-5">
                <div className="col-md-8 col-12">
                    <div className="card">

                        <div className="card-header">
                            <NavbarMio ruta={ruta} />
                        </div>

                        <div className="card-body">{children}</div>

                    </div>
                </div>
            </div>
        </div>
    )
}
